// extracted by mini-css-extract-plugin
export default {"message-body":"message-body--wMvaU03x","messageBody":"message-body--wMvaU03x"};